import React from "react";
import {
    DetailsPanelDiv,
    DetailsPanelLeftSection,
    DetailsPanelRightSection,
    SectionForDetailPanelLeftHeader,
    SectionForDetailPanelLeft,
    SectionForDetailPanelRight
  } from "./DependantTableDetailPanelStyles";

export default ({
    dependantDetails
}) => {
    
    return (
<DetailsPanelDiv>
      <DetailsPanelRightSection>
        <SectionForDetailPanelLeftHeader>
          <ul><strong>Member</strong></ul>
          <ul><strong>Membership Number</strong></ul>
        </SectionForDetailPanelLeftHeader>

        <SectionForDetailPanelLeft>
          <ul>{dependantDetails.member.name + " " + dependantDetails.member.surname}</ul>
          <ul>{dependantDetails.member.membershipId}</ul>
        </SectionForDetailPanelLeft>
      </DetailsPanelRightSection>

      <DetailsPanelLeftSection>
        <SectionForDetailPanelRight>
          <ul><strong>Address</strong></ul>
          <ul>{dependantDetails.member.address}</ul>
          <ul>{dependantDetails.member.area}</ul>
          <ul>{dependantDetails.member.postalCode}</ul>
        </SectionForDetailPanelRight>
      </DetailsPanelLeftSection>

      <DetailsPanelLeftSection>
        <SectionForDetailPanelRight>
          <ul><strong>Contact Details</strong></ul>

          <SectionForDetailPanelRight>
            <ul><strong>Cell</strong></ul>
            <ul><strong>Work</strong></ul>
            <ul><strong>Home</strong></ul>
            <ul><strong>Email</strong></ul>
          </SectionForDetailPanelRight>

          <SectionForDetailPanelRight>
            <ul>{dependantDetails.member.cellNumber}</ul>
            <ul>{dependantDetails.member.workNumber}</ul>
            <ul>{dependantDetails.member.homeNumber}</ul>
            <ul>{dependantDetails.member.email}</ul>
          </SectionForDetailPanelRight>
        </SectionForDetailPanelRight>
      </DetailsPanelLeftSection>
    </DetailsPanelDiv>
    )
}